import { render, staticRenderFns } from "./userMetadataListing.vue?vue&type=template&id=39a912ea&"
import script from "./userMetadataListing.vue?vue&type=script&lang=js&"
export * from "./userMetadataListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports